import { PureComponent } from "react"

/* Components */
import { Chip } from "../components"

/* Constants */
import { env, sound, tempstake, utils } from "../constants"

/* Picture */
import { Picture } from "../components"

/* UUID */
import { v4 as uuidv4 } from "uuid"



/* Widget Chips */
class Chips extends PureComponent {


    /* Set Chip Action */
    setChip = (index) => {

        /* Fields */
        const { setSelected } = this.props

        /* Set Selected */
        setSelected(index)

        /* Play Sound */
        sound.play("selectchip", 0.2)
    }

    /* Clear */
    clear = () => {

        /* Fields */
        const { setStake, setList } = this.props

        setStake({ ...tempstake })
        setList([])

        sound.play("cancel", 0.2)
    }


    /* Notify */
    notify = type => {

        /* Fields */
        const { notify } = this.props

        /* Show */
        notify(type, "show")

        /* Close */
        const timer = setTimeout(() => {
            notify(type, "close")
            clearTimeout(timer)
        }, 2000)
    }


    /* Cancel */
    cancel = () => {

        /* Fields */
        const { stake, setStake, list, setList } = this.props

        /* Get Last Index */
        const index = list.findLastIndex(e => e.type === "add")

        /* Recreate Fields */
        let _list = [...list]
        const _stake = { ...stake }

        /* Check Index */
        if (index > -1) {

            /* Get Last Element */
            const last = list[index]

            /* Double */
            if (last.isDouble) {

                /* Remove All */
                _list.forEach((item, index) => {
                    if (item.uuid === last.uuid) {
                        if (_stake[_list[index].target]) {
                            _stake[_list[index].target] = _stake[_list[index].target] - _list[index].value
                        }
                        _list[index].type = "remove"
                    }
                })

            }

            /* Refresh */
            else if (last.isRefresh) {
                setStake({ ...tempstake })
                setList([])
                sound.play("cancel", 0.2)
                return
            }

            /* Other Case */
            else {
                const value = _stake[last.target] - last.value
                _stake[last.target] = value
                _list[index].type = "remove"
            }

            /* Save */
            setStake(_stake)
            setList(_list)

            /* Play Sound */
            sound.play("cancel", 0.2)
        }
    }


    /* Double Action */
    double = () => {

        /* Fields */
        const { stake, setStake, list, setList, balance, max } = this.props

        /* Recreate Fields */
        const _list = [...list]
        const _stake = { ...stake }

        /* Max */
        const bonusMax = parseFloat(max) / 10
        const perfectPairMax = parseFloat(max) / 100 * 3

        /* Generate UUID */
        const uuid = uuidv4()
        let doubleTotal = 0
        let maxError = false

        /* Player */
        if (_stake.player) {
            if (_stake.player * 2 <= parseFloat(max)) {
                const value = _stake.player
                doubleTotal += value
                _stake.player *= 2
                _list.push({ value, type: "add", target: "player", uuid, isDouble: true })
            }
            else {
                maxError = true
            }
        }

        /* Banker */
        if (_stake.banker) {
            if (_stake.banker * 2 <= parseFloat(max)) {
                const value = _stake.banker
                doubleTotal += value
                _stake.banker *= 2
                _list.push({ value, type: "add", target: "banker", uuid, isDouble: true })
            }
            else {
                maxError = true
            }
        }

        /* Tie */
        if (_stake.tie) {
            if (_stake.tie * 2 <= bonusMax) {
                const value = _stake.tie
                doubleTotal += value
                _stake.tie *= 2
                _list.push({ value, type: "add", target: "tie", uuid, isDouble: true })
            }
            else {
                maxError = true
            }
        }

        /* Player Pair */
        if (_stake.playerPair) {
            if (_stake.playerPair * 2 <= bonusMax) {
                const value = _stake.playerPair
                doubleTotal += value
                _stake.playerPair *= 2
                _list.push({ value, type: "add", target: "playerPair", uuid, isDouble: true })
            }
            else {
                maxError = true
            }
        }

        /* Banker Pair */
        if (_stake.bankerPair) {
            if (_stake.bankerPair * 2 <= bonusMax) {
                const value = _stake.bankerPair
                doubleTotal += value
                _stake.bankerPair *= 2
                _list.push({ value, type: "add", target: "bankerPair", uuid, isDouble: true })
            }
            else {
                maxError = true
            }
        }

        /* Either Pair */
        if (_stake.eitherPair) {
            if (_stake.eitherPair * 2 <= bonusMax) {
                const value = _stake.eitherPair
                doubleTotal += value
                _stake.eitherPair *= 2
                _list.push({ value, type: "add", target: "eitherPair", uuid, isDouble: true })
            }
            else {
                maxError = true
            }
        }

        /* Perfect Pair */
        if (_stake.perfectPair) {
            if (_stake.perfectPair * 2 <= perfectPairMax) {
                const value = _stake.perfectPair
                doubleTotal += value
                _stake.perfectPair *= 2
                _list.push({ value, type: "add", target: "perfectPair", uuid, isDouble: true })
            }
            else {
                maxError = true
            }
        }

        if (maxError) {
            this.notify("maxBetError")
        }

        /* Check Balance */
        if (doubleTotal > balance) {
            this.notify("balanceError")
            return
        }
        else {
            setStake(_stake)
            setList(_list)
        }

        /* Play Sound */
        sound.play("sound", 0.2)
    }


    /* Refresh */
    refresh = () => {

        /* Fields */
        const { stake, last, setStake, setList, balance } = this.props

        /* Check */
        if (utils.getTotal(last) > 0 && utils.getTotal(stake) === 0) {

            /* Balance Error */
            if (utils.getTotal(last) > balance) {
                this.notify("balanceError")
                return
            }

            /* Get List */
            const _list = utils.reconnectionChipsList(last, true)

            /* Set Last Stake */
            setStake(last)

            /* Set List */
            setList(_list)

            /* Sound Play */
            sound.play("repeat", 0.2)
        }
    }

    /* Determine active button */
    isActive = type => {

        /* Fields */
        const { stake, last, list } = this.props

        if (type === "clear" || type === "double") {
            return utils.getTotal(stake) > 0
        }

        if (type === "cancel") {
            const i = list.findIndex(e => e.type === "add")
            return i !== -1
        }

        if (type === "refresh") {
            return utils.getTotal(last) > 0 && utils.getTotal(stake) === 0
        }

    }

    render = () => {

        /* Fields */
        const { selected, chips } = this.props

        const active = { opacity: 1 }
        const inactive = { opacity: 0.5, cursor: "default" }

        return (
            <div className="chips-container">

                <div onClick={() => this.clear()} className="chips-button" style={this.isActive("clear") ? active : inactive}>
                    <Picture src={`${env.mediapoint}/images/bet/delete.png`} alt="Delete" />
                    Очистить
                </div>

                <div onClick={() => this.cancel()} className="chips-button" style={this.isActive("cancel") ? active : inactive}>
                    <Picture src={`${env.mediapoint}/images/bet/cancel.png`} alt="Cancel" />
                    Отменить
                </div>

                <div className="chips-box">
                    {chips.map((chip, index) =>
                        <div onClick={() => this.setChip(index)} key={`${index}`} className={`chip ${selected === index ? "active" : "disabled"}`}>
                            <Chip color={chip.color} value={chip.value} size={70} />
                        </div>
                    )}
                </div>

                <div onClick={() => this.double()} className="chips-button" style={this.isActive("double") ? active : inactive}>
                    <span>2x</span>
                    Удвоить
                </div>

                <div onClick={() => this.refresh()} className="chips-button" style={this.isActive("refresh") ? active : inactive}>
                    <Picture src={`${env.mediapoint}/images/bet/refresh.png`} alt="Refresh" />
                    Повторить
                </div>

            </div>
        )
    }

}

export default Chips